const SYMBOLS_BY_CODE = {
  EUR: 'EUR',
  USD: '$',
  GBP: '£',
  MXN: '$',
  COP: '$',
  ARS: '$',
  CLP: '$',
  PEN: 'S/',
};

const BEFORE_DEFAULT_CODES = ['USD', 'GBP'];

export function getCurrencyCodeFromUser(user, fallback = 'EUR') {
  const code = String(user?.moneda_facturacion || fallback).trim().toUpperCase();
  return code || fallback;
}

export function getCurrencySymbol(code) {
  const upper = String(code || 'EUR').trim().toUpperCase();
  return SYMBOLS_BY_CODE[upper] || upper;
}

export function getCurrencyPosition(user, code) {
  const requested = String(user?.posicion_moneda_facturacion || '').trim().toLowerCase();
  if (requested === 'before' || requested === 'after') return requested;
  return BEFORE_DEFAULT_CODES.includes(String(code || '').toUpperCase()) ? 'before' : 'after';
}

export function formatMoney(value, options = {}) {
  const {
    code = 'EUR',
    symbol = getCurrencySymbol(code),
    position = BEFORE_DEFAULT_CODES.includes(String(code).toUpperCase()) ? 'before' : 'after',
    decimals = 2,
    locale = 'es-ES',
  } = options;
  const amount = Number(value || 0).toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return position === 'before' ? `${symbol} ${amount}` : `${amount} ${symbol}`;
}

export function getCurrencyConfig(user, fallback = 'EUR') {
  const code = getCurrencyCodeFromUser(user, fallback);
  return {
    code,
    symbol: getCurrencySymbol(code),
    position: getCurrencyPosition(user, code),
  };
}

